import React from "react";
import "../styles/portfolio.css";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { FiArrowRight } from "react-icons/fi";
import { Link } from "react-router-dom";
// import bannerBg from "../assets/images/promise-back.png";
// import portBg from "../assets/images/portss.jpg";
import { Helmet } from "react-helmet-async";
import Client from "../components/Client";
import bannerImg from "../assets/images/portfolio11.png";

function Portfolio() {
  const portfolioProjects = [
    {
      id: 1,
      title:
        "247DigiGrow - Amazon Reviews Management & Digital Marketing Platform",
      owner: "Adesh Sharma",
      category: "Web Development",
      description:
        "Comprehensive platform for managing Amazon product reviews and executing digital marketing campaigns. Helps sellers optimize their product visibility and reputation on Amazon.",
      technologies: ["Next.js", "Node.js", "MongoDB", "Amazon API"],
      impact:
        "Manages 500+ Amazon seller accounts with 95% review response rate",
      // image: "📦",
    },
    {
      id: 2,
      title: "Sankalp Ayurveda - Ayurvedic Medicines E-Commerce Platform",
      owner: "Dinesh Thakur",
      category: "Web Development + Automation",
      description:
        "Full-featured e-commerce platform for selling authentic Ayurvedic medicines and herbal products. Integrated with automated inventory management, lead generation, and customer engagement systems.",
      technologies: [
        "React.js",
        "Automation Tools",
        "Lead Generation",
        "Payment Gateway",
      ],
      impact: "50+ products sold, 2000+ monthly visitors, 35% conversion rate",
      // image: "🌿",
    },
    {
      id: 3,
      title: "SpeedRoutes - Courier & Delivery Management System",
      owner: "Sandeep Singh",
      category: "Web Development",
      description:
        "Complete delivery and courier management platform with real-time tracking, route optimization, and customer notifications. Streamlines logistics operations for efficient package delivery.",
      technologies: [
        "WordPress",
        "Custom Plugins",
        "Tracking System",
        "Payment Integration",
      ],
      impact: "Manages 500+ daily deliveries with 98% on-time delivery rate",
      // image: "🚚",
    },
    {
      id: 4,
      title: "EduiTalent - HR & IT Consultancy Platform",
      owner: "Ritu",
      category: "Web Development + Consultancy",
      description:
        "HR and IT consulting platform offering product consultancy with expertise in .NET, Java, AI, Python, and emerging technologies. Helps companies optimize their technical hiring and workforce solutions.",
      technologies: ["WordPress", ".NET", "Java", "AI", "Python"],
      impact: "20+ enterprise clients, 100+ successful placements yearly",
      // image: "💼",
    },
    {
      id: 5,
      title: "Amazon Reviews Optimization Campaign",
      owner: "Adesh Sharma - 247DigiGrow",
      category: "Digital Marketing",
      description:
        "Strategic Amazon seller optimization including review management, product listing optimization, and marketing automation to boost product rankings and sales.",
      technologies: ["Amazon API", "SEO Strategy", "Marketing Automation"],
      impact:
        "350% increase in product visibility, 150+ 5-star reviews generated",
      // image: "⭐",
    },
    {
      id: 6,
      title: "Sankalp Ayurveda Lead Generation Campaign",
      owner: "Dinesh Thakur - Sankalp",
      category: "Digital Marketing + Lead Generation",
      description:
        "Integrated lead generation and nurturing campaign for Ayurvedic products targeting health-conscious consumers through targeted digital marketing.",
      technologies: [
        "Lead Generation Tools",
        "Email Marketing",
        "Social Media",
        "Analytics",
      ],
      impact: "1000+ qualified leads monthly, 40% customer retention rate",
      // image: "📊",
    },
  ];

  return (
    <div>
      <Helmet>
        <title>
          Portfolio | Web Development & SEO Case Studies – Empower Web
        </title>

        <meta
          name="description"
          content="Explore our portfolio of web development, SEO & digital marketing projects. See real case studies, results & how we help businesses grow online."
        />

        {/* Canonical URL */}
        <link rel="canonical" href="https://empowerweb.in/portfolio" />

        {/* Open Graph */}
        <meta property="og:title" content="Our Portfolio - Empower Web" />
        <meta
          property="og:description"
          content="Discover our successful projects in web development, SEO, and digital marketing."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://empowerweb.in/portfolio" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Empower Web Portfolio - Proven Results"
        />
        <meta
          name="twitter:description"
          content="Check out our portfolio of web development and digital marketing success stories."
        />
      </Helmet>
      <Header />
      <Navbar />
      <main id="main-content">
        <section className="webbanner">
          <div className="webbanner-content">
            {/* <div className="webbanner-tag">Web Development </div> */}
            <h1>Meet Our Clients – Driving Digital Growth Since 2023</h1>
            <p>
              Since 2023, Empower Web has been helping businesses grow online
              with result-driven SEO, web development, and digital marketing
              solutions. We have successfully worked on projects including
              Medicines E-Commerce websites, Amazon Reviews Optimization
              Campaigns, and Sankalp Ayurveda Lead Generation Campaigns. Our
              focus is to build strong online visibility, generate quality
              leads, and deliver measurable business growth through innovative
              digital strategies.
            </p>
            <div className="webbanner-cta">
              <a href="./Contact" className="webbanner-btn primary">
                Get Free Consultation →
              </a>
            </div>
          </div>
          <div className="webbanner-image">
            <img
              src={bannerImg}
              width="400"
              height="300"
              alt="Web Development Solutions"
            />
          </div>
        </section>
        <div className="breadcrumb">
          <Link to="/">Home</Link>
          <span> / </span>
          <span>Our Portfolio</span>
        </div>
        <section className="portfolio-section">
          <div className="portfolio-container">
            <div className="portfolio-heading">
              <h2>
                Our Portfolio – Web Development & Digital Marketing Projects
              </h2>
              <p>
                At Empower Web, we have delivered high-performance websites, SEO
                campaigns, and digital solutions across multiple industries. Our
                portfolio showcases real results including increased traffic,
                higher conversions, and improved online visibility.
              </p>
            </div>

            <div className="portfolio-grid">
              {portfolioProjects.map((project) => (
                <div
                  className="portfolio-card"
                  key={project.id}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow =
                      "0 10px 30px rgba(8, 104, 160, 0.15)";
                    e.currentTarget.style.transform = "translateY(-5px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = "none";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  <div className="portfolio-icon">{project.image}</div>

                  <h3>{project.title}</h3>

                  <p className="owner">
                    Owner: <strong>{project.owner}</strong>
                  </p>

                  <span className="category">{project.category}</span>

                  <p className="description">{project.description}</p>

                  <div className="tech-section">
                    <p>Technologies:</p>
                    <div className="tech-list">
                      {project.technologies.map((tech, idx) => (
                        <span key={idx}>{tech}</span>
                      ))}
                    </div>
                  </div>

                  <div className="impact">✓ {project.impact}</div>
                </div>
              ))}
            </div>
          </div>
        </section>
        {/* <section className="stats-section">
        <div className="stats-grid">
          <div>
            <h3>50+</h3>
            <p>Projects Completed</p>
          </div>
          <div>
            <h3>200+</h3>
            <p>Happy Clients</p>
          </div>
          <div>
            <h3>5+</h3>
            <p>Years of Experience</p>
          </div>
          <div>
            <h3>15+</h3>
            <p>Team Members</p>
          </div>
        </div>
      </section> */}
        <Client />
        <section className="cta-section">
          <div className="cta-content">
            <h2>Ready to Grow Your Business?</h2>
            <br />
            <p>
              Let’s build a high-converting website or SEO strategy for your
              business.
            </p>
            <a href="/contact" className="cta-btn">
              Get Free Consultation <FiArrowRight />
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default Portfolio;
